<template>
<div class="Basket page">
  <div>
    <section class="title py-6 mb-4">
      <h1 class="font-lg">Корзина</h1>
    </section>
    <section class="main">
      <div v-if="basketUser && basketUser.items.length">
        <div class="basket-preview d-flex gap-4 flex-column">
          <div v-for="item of basketUser.items" :key="item.id">
            <BasketPreview
              :item="item"
            />

          </div>
        </div>
        <div class="promocode-block">
          <div class="my-3 d-flex gap-4 d-flex align-center">
            <v-text-field
              outlined
              dense
              class="col-3 py-1"
              placeholder="Промокод, если есть"
              hide-details
            />
            <v-btn outlined  rounded large>
              Применить
            </v-btn>
          </div>
        </div>
        <div class="offert-block d-flex align-center col-12">
          <v-checkbox
            hide-details
            class="ma-0 pa-0"
            v-model="agreeOffert"
            dense

          />
          <span>Я согласен с условиями <a href="/">оферты</a></span>
        </div>
        <div class="result-block pb-5 mt-3" v-if="Number(basketUser.total_price)">
          <h4>
            Итого:
          </h4>
          <span>
          {{basketUser.total_price}} ₽
        </span>
        </div>
        <div class="btn-block">
          <v-btn
            large
            class="background_transparent"
            color="white"
            outlined
            @click="goToCatalog"
          >
            <v-icon left>mdi-plus</v-icon> Добавить услугу
          </v-btn>
          <v-btn
            large
            class="background_transparent"
            color="white"
            outlined
            @click="clearFullBasket"
          >
            Очистить корзину
          </v-btn>
          <v-btn
            large
            color="white"
            outlined
            @click="goToPay"
          >
            Оформить заказ
          </v-btn>

        </div>
      </div>
      <div v-else>
        <h3 class="pb-4"> В корзине пока пусто </h3>
        <p class="ma-0">Перейдите в каталог для выбора тестов или услуг </p>
        <div class="btn-block justify-start pt-7">
          <v-btn
            large
            color="white"
            outlined
            @click="goToCatalog"
          >
            Перейти в каталог
          </v-btn>

        </div>
      </div>
    </section>
  </div>
  <modal-with-action
    :title="'Оплата прошла успешно'"
    :accept-button="'Перейти к тесту'"
    :text="'Тест добавлен в раздел «Мои услуги и тесты». Вы можете пройти его прямо сейчас или вернуться к нему позже.'"
    :widthModal="580"
    :cancelButton="false"
    :show-modal="showSuccessPay"
    :image-slot="true"
    @closeModal="hideSuccessPay"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          src="@/assets/images/adminPanel/success.webp"
          max-width="200px"
          aspect-ratio="1"
          position="center"
        />
      </div>

    </template>
  </modal-with-action>
  <modal-with-action
    :title="'Не удалось выполнить оплату'"
    :accept-button="'Попробовать еще раз'"
    :text="'Произошла ошибка при попытке списания средств. Пожалуйста, попробуйте снова или используйте другой способ оплаты.'"
    :widthModal="580"
    :cancelButton="false"
    :show-modal="showFailedPay"
    :image-slot="true"
    @closeModal="hideFailedPay"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          src="@/assets/images/adminPanel/failed.webp"
          max-width="200px"
          aspect-ratio="1"
          position="center"
        />
      </div>

    </template>
  </modal-with-action>
  <modal-with-action
    :title="createdOrderId ? `Заказ №${createdOrderId} оформлен` : 'Заказ оформлен'"
    :accept-button="'Мои заказы'"
    :text="'Статус: «Ожидает оплаты». В ближайшее время с вами свяжется менеджер. После оплаты тесты появятся в остатках компании.'"
    :widthModal="580"
    :cancelButton="false"
    :show-modal="showCreateOrder"
    :image-slot="true"
    @closeModal="hideCreateOrder"
    @accept="goToMyOrders"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          src="@/assets/images/adminPanel/success.webp"
          max-width="200px"
          aspect-ratio="1"
          position="center"
        />
      </div>

    </template>
  </modal-with-action>
  <div v-if="loading" class="h-100 d-flex justify-center align-center">
    <v-progress-circular :size="50" color="primary" indeterminate/>
  </div>
</div>
</template>

<script>
import BasketPreview from '@/components/basket/BasketPreview.vue';
import ModalWithAction from '@/components/admin-panel/Modal/ModalWithAction.vue';
import { mapActions, mapGetters } from 'vuex';
import { ADMIN } from '@/common/constants/userTypes';

/**
 * Компонент: Basket
 * Описание:
 */
export default {
  name: 'Basket',

  components: { ModalWithAction, BasketPreview },

  props: {},

  data() {
    const agreeOffert = null;
    const showSuccessPay = false;
    const showFailedPay = false;
    const showCreateOrder = false;
    return {
      agreeOffert,
      showSuccessPay,
      showFailedPay,
      showCreateOrder,
      createdOrderId: null,
    };
  },

  computed: {
    ...mapGetters({
      basketUser: 'basket/basket/basketUser',
      loading: 'basket/basket/loading'
    }),
  },

  watch: {},

  created() {
  },

  mounted() {
    this.fetchUserBasket();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      fetchUserBasket: 'basket/basket/fetchUserBasket',
      clearBasket: 'basket/basket/clearBasket',
      createOrder: 'basket/basket/createOrder'

    }),
    goToMyOrders() {
      this.showCreateOrder = false;
      const user = this.$store.getters['auth/user'];
      this.$router.push({ name: user && user.user_type === ADMIN ? 'orders' : 'my-orders' });
    },
    goToCatalog() {
      this.$router.push('/list-services');
    },

    async goToPay() {
      const res = await this.createOrder();
      if (res.id) {
        this.createdOrderId = res.id;
        this.showCreateOrder = true;
        await this.fetchUserBasket();
      }
    },

    hideSuccessPay() {
      this.showSuccessPay = false;
    },

    hideFailedPay() {
      this.showFailedPay = false;
    },

    hideCreateOrder() {
      this.showCreateOrder = false;
    },
    async clearFullBasket() {
      await this.clearBasket();
      await this.fetchUserBasket();
    },
    goToTelegram() {
      window.open('https://t.me/Team_Assessment', '_blank');
    }
  },
};
</script>

<style scoped lang="scss">
.Basket {
  /* Стили компонента */
  & section.main {
    background: white;
    padding: 24px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 1200px;
    & .result-block{
      display: flex;
      justify-content: space-between;
      & h4{
        font-size: 20px;
        font-weight: 600;
        color: black;
      }
      & span{
        font-size: 20px;
        font-weight: 600;
        color: var(--color-blue-500);
      }
    }
    & .btn-block{
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      & .v-btn{
        background: var(--color-blue-500);
        border-radius: 6px;
        font-size: 16px;
        width: 100%;
        max-width: 200px;
        padding: 10px 16px;
        ::v-deep span{
          line-height: 24px;
        }
        &.background_transparent{
          background: transparent;
          color: var(--color-blue-500)!important;
        }
      }
    }
  }
}
</style>
